import { useDecision } from '@optimizely/react-sdk'
import useFeatureToggle from '@space-shell/common/hooks/useFeatureToggle'
import useGamificationToggle from '@space-shell/common/hooks/useGamificationToggle'
import { Toggles } from '@space-shell/common/services/toggle'

export function useHeaderExperiments() {
  const notificationConsumerToggle = useFeatureToggle({
    toggleName: Toggles.EnableNotificationConsumer
  })

  const gamificationToggle = useGamificationToggle()
  const [enableMembershipChat] = useDecision('enable_membership_chat')
  const [enableGlobalSearch] = useDecision('lex_enable_global_search_for_products')

  return {
    isNotificationsEnabled: Boolean(notificationConsumerToggle.data),
    isGamificationEnabled: Boolean(gamificationToggle.data),
    isGlobalSearchEnabled: enableGlobalSearch.enabled,
    isMembershipChatEnabled: enableMembershipChat.enabled
  } as const
}
